import * as React from 'react';
import { Typography } from '@mui/material';
import DOMPurify from 'isomorphic-dompurify';

import { CustomModal, PrimaryButton, SecondaryButton } from 'components/molecules';
import { ErrorCircleIcon, SuccessCircleIcon, WarningCircleIcon } from 'assets/icons';
import { ConfirmationOptions } from './interface';
import './styles.scss';

interface ConfirmationDialogProps extends ConfirmationOptions {
  open: boolean;
  onSubmit: () => void;
  onClose: () => void;
  confirmButtonTxt?: string;
  cancelButtonTxt?: string;
  variant: 'confirm' | 'info' | undefined;
  icon?: 'success' | 'error' | 'warning' | undefined;
  message: string | undefined;
  isHtmlMessage: boolean;
}

const ConfirmationDialog = ({
  open,
  icon,
  variant,
  message,
  onSubmit,
  onClose,
  confirmButtonTxt,
  cancelButtonTxt,
  containerRef,
  isHtmlMessage,
}: ConfirmationDialogProps) => (
  <CustomModal open={open} onClose={onClose} modalClass="confirm-alert-modal" container={containerRef}>
    <div className="d-flex flex-column justify-content-center align-items-center">

      {icon && icon === 'success' && (
        <div className="mb-2">
          <SuccessCircleIcon sx={{ width: '60px', height: '60px' }} />
        </div>
      )}

      {icon && icon === 'error' && (
        <div className="mb-2">
          <ErrorCircleIcon sx={{ width: '60px', height: '60px' }} />
        </div>
      )}

      {icon && icon === 'warning' && (
        <div className="mb-2">
          <WarningCircleIcon sx={{ width: '60px', height: '60px' }} />
        </div>
      )}

      {!isHtmlMessage && (
      <Typography variant="h5" sx={{ mb: 3, textAlign: 'center', whiteSpace: 'pre-line' }}>
        {message}
      </Typography>
      )}

      {isHtmlMessage && (
      <div className="htmlDescription" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message ?? '') }} />
      )}

      {variant === 'confirm' && (
        <div className="row w-100">
          <div className="col-12 col-md-6 mb-2 mb-md-0">
            <PrimaryButton fullWidth onClick={onSubmit}>
              {confirmButtonTxt}
            </PrimaryButton>
          </div>
          <div className="col-12 col-md-6">
            <SecondaryButton fullWidth onClick={onClose}>
              {cancelButtonTxt}
            </SecondaryButton>
          </div>
        </div>
      )}

      {variant === 'info' && (
        <div className="row">
          <div className="col-12">
            <PrimaryButton fullWidth onClick={onSubmit}>
              {confirmButtonTxt}
            </PrimaryButton>
          </div>
        </div>
      )}

    </div>
  </CustomModal>
);

ConfirmationDialog.defaultProps = {
  icon: undefined,
  confirmButtonTxt: 'Ok',
  cancelButtonTxt: 'Cancel',
};

export default ConfirmationDialog;
